import AgencyUser from "./AgencyUser.js";
import ConsultantRole from "./role/ConsultantRole.js";

/**
 * A user who is consultant for an agency.
 */
export default class AgencyConsultant extends AgencyUser {
	isConsultant() {
		return true;
	}

	getRoles() {
		// TODO: This method and its class will be deleted by
		// FTGP-5715
		return [
			new ConsultantRole({
				agencyId: this.getAgencyId(),
				companyIds: this.getCompanyIds(),
			}),
		];
	}

	_defaultTypeOfUser() {
		return "AgencyConsultant";
	}

	static possibleTypes() {
		return ["AgencyConsultant"];
	}
}
